/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Section_0_HeadingInputs */

const en_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where conventional instruction goes wrong`)
};

const es_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dónde falla la instrucción convencional`)
};

const de_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo der herkömmliche Unterricht danebenliegt`)
};

const zh_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`传统教学错在哪里`)
};

const ar_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أين يخطئ التعليم التقليدي`)
};

const fr_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Là où l’enseignement traditionnel fait fausse route`)
};

const vi_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỗ sai của hướng dẫn thông thường`)
};

const sw_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafunzo ya kawaida hukosea wapi`)
};

const th_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จุดที่การสอนแบบดั้งเดิมผิดพลาด`)
};

const bs_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdje konvencionalna nastava griješi`)
};

const ja_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`従来の指導はどこで間違うのか`)
};

const ko_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기존 레슨은 어디서 잘못되는가`)
};

const pt_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde o ensino convencional erra`)
};

const it_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove sbaglia l’insegnamento tradizionale`)
};

const sv_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Där traditionell undervisning går fel`)
};

const nl_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar traditionele les de mist in gaat`)
};

const da_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor traditionel undervisning går galt`)
};

const nb_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der tradisjonell undervisning tar feil`)
};

const fi_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missä perinteinen opetus menee vikaan`)
};

const pl_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdzie tradycyjne nauczanie popełnia błąd`)
};

const ru_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В чём ошибается традиционное обучение`)
};

const tr_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geleneksel eğitim nerede yanılıyor`)
};

const hi_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पारंपरिक प्रशिक्षण कहाँ गलत होता है`)
};

const id_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di mana pengajaran konvensional keliru`)
};

const ms_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di mana bimbingan konvensional tersilap`)
};

const cs_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kde konvenční výuka selhává`)
};

const el_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πού κάνει λάθος η παραδοσιακή διδασκαλία`)
};

const he_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היכן ההדרכה המקובלת טועה`)
};

const af_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar konvensionele instruksie fout gaan`)
};

const hu_injury_content_section_0_heading = /** @type {(inputs: Injury_Content_Section_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hol hibázik a hagyományos oktatás`)
};

/**
* | output |
* | --- |
* | "Where conventional instruction goes wrong" |
*
* @param {Injury_Content_Section_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_section_0_heading = /** @type {((inputs?: Injury_Content_Section_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Section_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_section_0_heading(inputs)
	if (locale === "de") return de_injury_content_section_0_heading(inputs)
	if (locale === "zh") return zh_injury_content_section_0_heading(inputs)
	if (locale === "ar") return ar_injury_content_section_0_heading(inputs)
	if (locale === "fr") return fr_injury_content_section_0_heading(inputs)
	if (locale === "vi") return vi_injury_content_section_0_heading(inputs)
	if (locale === "sw") return sw_injury_content_section_0_heading(inputs)
	if (locale === "th") return th_injury_content_section_0_heading(inputs)
	if (locale === "bs") return bs_injury_content_section_0_heading(inputs)
	if (locale === "ja") return ja_injury_content_section_0_heading(inputs)
	if (locale === "ko") return ko_injury_content_section_0_heading(inputs)
	if (locale === "pt") return pt_injury_content_section_0_heading(inputs)
	if (locale === "it") return it_injury_content_section_0_heading(inputs)
	if (locale === "sv") return sv_injury_content_section_0_heading(inputs)
	if (locale === "nl") return nl_injury_content_section_0_heading(inputs)
	if (locale === "da") return da_injury_content_section_0_heading(inputs)
	if (locale === "nb") return nb_injury_content_section_0_heading(inputs)
	if (locale === "fi") return fi_injury_content_section_0_heading(inputs)
	if (locale === "pl") return pl_injury_content_section_0_heading(inputs)
	if (locale === "ru") return ru_injury_content_section_0_heading(inputs)
	if (locale === "tr") return tr_injury_content_section_0_heading(inputs)
	if (locale === "hi") return hi_injury_content_section_0_heading(inputs)
	if (locale === "id") return id_injury_content_section_0_heading(inputs)
	if (locale === "ms") return ms_injury_content_section_0_heading(inputs)
	if (locale === "cs") return cs_injury_content_section_0_heading(inputs)
	if (locale === "el") return el_injury_content_section_0_heading(inputs)
	if (locale === "he") return he_injury_content_section_0_heading(inputs)
	if (locale === "af") return af_injury_content_section_0_heading(inputs)
	if (locale === "hu") return hu_injury_content_section_0_heading(inputs)
	return en_injury_content_section_0_heading(inputs)
});